import { render, staticRenderFns } from "./account-transfer-list.vue?vue&type=template&id=cf5d8e7e&"
import script from "./account-transfer-list.vue?vue&type=script&lang=js&"
export * from "./account-transfer-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports